// client/src/modals/LabGradingRubric.jsx

import React from 'react';

const LabGradingRubric = ({ 
  labAIGradingCriteria, 
  questionId, 
  isExpanded, 
  onToggle, 
  role, 
  onEditRubric 
}) => {
  if (!labAIGradingCriteria || labAIGradingCriteria.length === 0) return null;

  return (
    <div className="am-rubric-panel">

      {/* Header — matches renderRubricView style exactly */}
      <div className="am-rubric-panel-header" onClick={() => onToggle(questionId)} style={{ cursor: 'pointer' }}>
        <strong>🤖 Prof-iX Grading Rubric</strong>
        <button type="button" className="am-btn am-btn--sm am-btn--rubric-view">
          {isExpanded ? '▲ Hide' : '▼ View'}
        </button>
      </div>

      {/* Expanded content */}
      {isExpanded && (
        <div className="am-rubric-full">
          <span className="am-section-title">Grading Criteria</span>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '8px' }}>
            {labAIGradingCriteria.map((req, rIdx) => {
              if (!req.rubric) return null;
              return (
                <div key={rIdx} className="am-section" style={{ padding: '12px 14px' }}>

                  {/* Criterion header */}
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                    <span style={{ fontWeight: 700, fontSize: '13px', color: 'var(--m-text-primary)' }}>
                      {req.description}
                    </span>
                    <span className="am-points-badge">
                      {req.points} pts ({req.percentage}%)
                    </span>
                  </div>

                  {/* Criterion tiers */}
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', fontSize: '13px', color: 'var(--m-text-secondary)' }}>
                    <p style={{ margin: 0 }}>
                      <strong style={{ color: 'var(--m-green)' }}>✓ Full Credit:</strong> {req.rubric.full}
                    </p>

                    {req.rubric.partial?.length > 0 && (
                      [...req.rubric.partial]
                        .sort((a, b) => b.threshold - a.threshold)
                        .map((tier, tIdx) => (
                          <p key={tIdx} style={{ margin: 0 }}>
                            <strong style={{ color: 'var(--m-amber)' }}>◐ Partial (≥{tier.threshold}%):</strong> {tier.description}
                            <span style={{ color: 'var(--m-text-faint)', marginLeft: '6px', fontSize: '12px' }}>
                              ({(req.points * tier.pointsPercentage).toFixed(1)} pts)
                            </span>
                          </p>
                        ))
                    )}

                    <p style={{ margin: 0 }}>
                      <strong style={{ color: 'var(--m-red)' }}>✗ No Credit:</strong> {req.rubric.fail}
                    </p>
                  </div>

                </div>
              );
            })}
          </div>

          {role === 'instructor' && onEditRubric && (
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '12px' }}>
              <button type="button" className="am-btn am-btn--sm am-btn--rubric-view" onClick={onEditRubric}>
                ✏️ Edit Rubric
              </button>
            </div>
          )}
        </div>
      )}

    </div>
  );
};

export default LabGradingRubric;
